module.exports = __webpack_public_path__ + "static/media/gk3dN4E1.d1f0f902.jpg";